// Montagem de URL com UTM (pura, testada).

export interface UtmFields {
  readonly url: string;
  readonly source: string;
  readonly medium: string;
  readonly campaign: string;
  readonly content: string;
  readonly term: string;
}

export const EMPTY_UTM_FIELDS: UtmFields = { url: "", source: "", medium: "", campaign: "", content: "", term: "" };

export const UTM_PARAM_KEYS = ["source", "medium", "campaign", "content", "term"] as const;
export const REQUIRED_UTM_KEYS = ["source", "medium", "campaign"] as const;
const MAX_PARAM_LENGTH = 200;

export type UtmBuildResult = { readonly ok: true; readonly url: string } | { readonly ok: false; readonly error: string };

/** Valida e monta a URL; parametros utm_* existentes na base sao substituidos. */
export function buildUtmUrl(fields: UtmFields): UtmBuildResult {
  const base = fields.url.trim();
  let parsed: URL;
  try {
    parsed = new URL(base);
  } catch {
    return { ok: false, error: "URL base inválida. Use uma URL completa (ex: https://exemplo.com)." };
  }
  if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
    return { ok: false, error: "A URL base precisa começar com http:// ou https://." };
  }
  const missing = REQUIRED_UTM_KEYS.filter((key) => !fields[key].trim());
  if (missing.length > 0) {
    return { ok: false, error: `Preencha ${missing.map((key) => `utm_${key}`).join(", ")}.` };
  }
  if (UTM_PARAM_KEYS.some((key) => fields[key].trim().length > MAX_PARAM_LENGTH)) {
    return { ok: false, error: `Cada parâmetro aceita no máximo ${MAX_PARAM_LENGTH} caracteres.` };
  }
  for (const key of UTM_PARAM_KEYS) {
    const value = fields[key].trim();
    if (value) {
      parsed.searchParams.set(`utm_${key}`, value);
    } else {
      parsed.searchParams.delete(`utm_${key}`);
    }
  }
  return { ok: true, url: parsed.toString() };
}
